module.exports = __webpack_public_path__ + "0630d712f56118344702e42f83c93854.png";